import React from 'react';
import { connect } from 'react-redux';
import isEmpty from 'lodash.isempty';
import PropTypes from 'prop-types';

import { Text } from 'next/components/ui';
import LoadingIcon from 'assets/images/checkout-loading.svg';
import {
  selectPaymentTaxes,
  selectLoadingTaxes,
  selectSubscription,
} from 'reducers/newBilling';
import { formatCurrency, formatNumber } from 'utils/billing';
import PlanSavings from './PlanSavings';

import {
  StyledHeading,
  StyledText,
  Caption,
  CheckoutRow,
  DueTodayText,
  IntervalInfo,
  PayButton,
  PoweredByStripeWrapper,
  PoweredByText,
  LoadingSpinner,
  LockIcon,
  StripeIcon,
  StyledPanel,
} from './styled';

export const CheckoutSummary = ({
  completedForms,
  isSubmitting,
  formValues,
  planData,
  subscriptionTaxes,
  taxesLoading,
}) => {
  return (
    <StyledPanel>
      <StyledHeading>Appcues {planData?.name ?? ''}</StyledHeading>

      <StyledText>
        Up to {formatNumber(planData?.planLimit) ?? ''} Monthly active users
        (MAUs)
      </StyledText>

      <CheckoutRow layout="vertical">
        <IntervalInfo spacing={planData.planInterval === 'yearly'}>
          <Text>Billed {planData.cadence}</Text>
          <Text bold>
            {formatCurrency(planData.price) || ''}/{planData.period}
          </Text>
        </IntervalInfo>

        <PlanSavings planData={planData} spacing={false} />
      </CheckoutRow>

      {!isEmpty(formValues) && !!subscriptionTaxes && subscriptionTaxes !== 0 && (
        <CheckoutRow>
          <Text>Sales tax</Text>
          {taxesLoading ? (
            <LoadingSpinner src={LoadingIcon} alt="stripe icon" />
          ) : (
            <Text bold>{formatCurrency(subscriptionTaxes) || '-'}</Text>
          )}
        </CheckoutRow>
      )}

      <CheckoutRow borderless>
        <DueTodayText bold>Due Today</DueTodayText>
        <DueTodayText bold>
          {(completedForms.billing &&
            formatCurrency(planData.price + subscriptionTaxes)) ||
            '-'}
        </DueTodayText>
      </CheckoutRow>

      <Caption>
        Accounts that exceed their MAU limit will be upgraded for the next
        billing period.
      </Caption>

      <PayButton
        disabled={
          !completedForms?.billing ||
          !completedForms?.paymentMethod ||
          isSubmitting
        }
        type="submit"
      >
        {isSubmitting ? (
          <LoadingSpinner src={LoadingIcon} alt="stripe icon" />
        ) : (
          'Buy now'
        )}
      </PayButton>

      <PoweredByStripeWrapper>
        <LockIcon icon="lock" />
        <PoweredByText>Secure payments powered by</PoweredByText>
        <StripeIcon icon={['fab', 'stripe']} className="fa-lg" />
      </PoweredByStripeWrapper>
    </StyledPanel>
  );
};

const mapStateToProps = state => {
  return {
    subscriptionTaxes: selectPaymentTaxes(state),
    taxesLoading: selectLoadingTaxes(state),
    subscription: selectSubscription(state),
  };
};

const mapDispatchToProps = () => ({});

CheckoutSummary.propTypes = {
  completedForms: PropTypes.shape({
    billing: PropTypes.bool,
    paymentMethod: PropTypes.bool,
  }),
  isSubmitting: PropTypes.bool,
  formValues: PropTypes.object,
  planData: PropTypes.shape({
    name: PropTypes.string,
    planLimit: PropTypes.number,
    planInterval: PropTypes.string,
    cadence: PropTypes.string,
    price: PropTypes.number,
    period: PropTypes.string,
    savings: PropTypes.number,
  }),
  subscriptionTaxes: PropTypes.number,
  taxesLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutSummary);
